import {
    get,
    post
} from './../http.js'
import router from '../../src/router'
import {
    Toast
} from 'vant';
import {format} from '../Date.js'
import {getRandomNumber} from '../until.js'


const NowDate = format(new Date(), 'YYYY-MM-DD');
var AcceptanceInfoList={
                            ISDomestic: '0',
                            ISDomesticMC:'国产',
                            JJSBBZ: '0',
                            TZSBBZ: '0',
                            SFQJ: 'N',
                            GYSB: '0',
                            SFCYXYFX: 'N',
                            QDRQ: NowDate,
                            GRRQ: NowDate,
                            BXRQ: NowDate,
                            SSRQ: NowDate,
                            PJBZ: 'N',
                            zczj: 0,
                            kyjf: 0,
                            jxjf: 0,
                            jsjz: 0,
                            zfbk: 0,
                            rzzl: 0,
                            qt: 0,
                            SL: 0,
                            CGDJ: 0,
                            ZJE: 0,
                            HH: 0,
                            WYSSL:'0',
                            JFKS: '',
                            JFKSMC: ''
                        };
    const ISDomesticArray = [{
        id: '0',
        name: '国产'
    }, {
        id: '1',
        name: '进口'
    }, {
        id: '2',
        name: '未知'
    }];


export function AcceptanceOfTheJump(item) {

    get('api/CheckIncoming/LoadAcceptanceInfo', {
        Token: 'YTDF5EF3A6174564E5981A446158F106',
        SBBH: item.SBBH,
        HTBH: item.HTBH,
        ID: item.Id
    }).then(result => {
        var data = {};
        let requestData = result.AcceptanceInfoList[0];
            AcceptanceInfoList.SBBM = requestData.SBBM,
            AcceptanceInfoList.PPMC = requestData.PPMC,
            AcceptanceInfoList.SBPP = requestData.PP,
            AcceptanceInfoList.CDMC = requestData.CDMC,
            AcceptanceInfoList.CD = requestData.CD,
            AcceptanceInfoList.GBMC = requestData.GBMC,
            AcceptanceInfoList.GB = requestData.GB,
            AcceptanceInfoList.SBGG = requestData.GGXH,
            AcceptanceInfoList.SBDW = requestData.DW,
            AcceptanceInfoList.KJKMMC = requestData.KJKMMC,
            AcceptanceInfoList.KJKM = requestData.KJKM,
            AcceptanceInfoList.ZCZJH = requestData.ZCZJH,
            AcceptanceInfoList.IsContract=true;
            AcceptanceInfoList.GLLB='1';
            AcceptanceInfoList.GYSMC = requestData.GYSMC,
            AcceptanceInfoList.GYSBH = requestData.HTDW,
            AcceptanceInfoList.GYSLXR = requestData.WXRXM, //供应商联系人
            AcceptanceInfoList.GYSDH = requestData.WXDH, //供应商电话
            AcceptanceInfoList.WXGSMC = requestData.WXDWMC, //维修公司名称
            AcceptanceInfoList.WXGS = requestData.WXDW, //维修公司
            AcceptanceInfoList.WXLXR = requestData.WXRXM, //维修联系人
            AcceptanceInfoList.WXLXDH = requestData.WXDH,
            AcceptanceInfoList.SCQYMC = requestData.SCCSMC,
            AcceptanceInfoList.SCQY = requestData.SCCS,
            AcceptanceInfoList.LSBH= getRandomNumber(12),
            AcceptanceInfoList.SBMCBH = item.SBBH,
            AcceptanceInfoList.SBMC = item.MC,

            AcceptanceInfoList.BXRQ = item.YXRQ,
            AcceptanceInfoList.CGDJ = item.DJ,
            AcceptanceInfoList.WYSSL = requestData.WYSSL,
            AcceptanceInfoList.SL = item.SL,
            AcceptanceInfoList.HTId = item.Id,
            AcceptanceInfoList.HTBH = item.HTBH,
            AcceptanceInfoList.HTJG = item.HTJE,
            AcceptanceInfoList.HTMC = item.HTMC,
            AcceptanceInfoList.TotalJE = item.SL * item.DJ,
            AcceptanceInfoList.ZJE = item.SL * item.DJ;
            // 序列号相关字段（从接口返回的设备预设数据）
            AcceptanceInfoList.SBXLHS = requestData.SBXLHS || '';
            AcceptanceInfoList.SBXLHIDStr = requestData.SBXLHIDStr || '';
        let ISDomesticData = ISDomesticArray.find(x => x.id === requestData.ISDomestic);
        AcceptanceInfoList.ISDomesticMC = ISDomesticData ? ISDomesticData.name : '国产';
        AcceptanceInfoList.ISDomestic = ISDomesticData ? ISDomesticData.id : '0';
        router.push({
            name: 'EquipmentAcceptanceDetails',
            params: {
                AcceptanceInfoList: AcceptanceInfoList,
                AZYS: [],
                IsAddOrUpdata: false
            }
        })
    })
}



//////////////////
// WEBPACK FOOTER
// ./tool/api/StorageInspection.js
// module id = null
// module chunks = 